import { useQuery } from "@apollo/client";
import { SignedUrlToGetFileDocument } from "../../__generated__/graphql";

export default function useSignedUrlToGetFile(
  bucketKey: string | null | undefined
) {
  const { data, loading, error } = useQuery(SignedUrlToGetFileDocument, {
    variables: { bucketKey: bucketKey ?? "" },
    skip: !bucketKey,
  });

  return { data, loading, error };
}
